import Button from 'components/button/button';

export default Button;
